export const XPX_PERPS_WITHDRAWAL_PERMISSION_RESOURCE = 'xpx-perps:withdrawal';
